import React, { useMemo } from "react";
import "../../utils/StockSummaryCard.css";

const StockSummaryCards = ({ data = [] }) => {
  const totalStock = useMemo(() => {
    return data.reduce((sum, item) => sum + (item.total || 0), 0);
  }, [data]);

  return (
    <div className="stock-summary-wrapper">
      <div className="stock-summary-grid">
        {data.map((item, index) => (
          <div
            key={`${item.name}-${index}`}
            className={`stock-summary-card ${
                item.name === "Autres"
                ? "stock-summary-card-others"
                : ""
            }`}
          >
            <div className="stock-summary-card-name">
              {item.name}
            </div>

            <div className="stock-summary-card-value">
              {item.total.toLocaleString()}
            </div>

            <div className="stock-summary-card-label">
              unités
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StockSummaryCards;